import React from 'react';
import { FaCloudUploadAlt } from "react-icons/fa";

const UploadButton = ({ lable = "Upload" }) => {
    return (
        <button
            type="submit"
            className="group relative inline-flex h-10 items-center justify-center overflow-hidden rounded-lg bg-main-blue text-main-white xl:px-6 lg:px-6 px-12 transition hover:bg-main-blue/80 hover:scale-105"
        >
            {/* Icon */}

            <span className='flex items-center'><FaCloudUploadAlt className="mr-2" size={18} />{lable}</span>

            {/* Animation effect */}
            <div className="absolute inset-0 flex h-full w-full justify-center transform skew-x-[-12deg] translate-x-[-100%] group-hover:duration-1000 group-hover:transform group-hover:translate-x-[100%]">
                <div className="relative h-full w-8 bg-white/20"></div>
            </div>
        </button>
    );
};

export default UploadButton;
